import React, { useMemo } from 'react';
import { ResourceDetailsResponse } from '../../../../../primary-record-types/apiTypes/medicalDataService';
import { MedicalDataTypes } from '../../../../../primary-record-types';
import Stack from '../../../../v2BaseComponents/Stack';
import Text from '../../../../v2BaseComponents/Text';
import { resourceTypeGuards } from '../../../../../utils/medicalDataUtils';

export type ClinicalImpressionsOwnProps = {
    resource: ResourceDetailsResponse<MedicalDataTypes.PrimaryRecordResource>;
};

export type ClinicalImpressionsProps = ClinicalImpressionsOwnProps;

type TitleGroups = {
    title: string;
    summaries: string[];
};

const emptyArray: MedicalDataTypes.ResourceClinicalImpression[] = [];

const ClinicalImpressions: React.FC<ClinicalImpressionsProps> = (props) => {
    let clinicalImpressions = emptyArray;
    const resource = props.resource.resource;

    if (resourceTypeGuards.isVisit(resource)) {
        clinicalImpressions = resource.clinicalImpressions || emptyArray;
    }
    const grouped = useMemo<TitleGroups[]>(
        () =>
            clinicalImpressions.reduce<TitleGroups[]>((acc, ci) => {
                if (ci.title) {
                    acc.push({
                        title: ci.title,
                        summaries: [],
                    });
                }
                if (acc.length) {
                    acc[acc.length - 1].summaries.push(ci.summary);
                }
                return acc;
            }, []),
        [clinicalImpressions],
    );

    if (!grouped.length) return null;

    return (
        <Stack space={2} vertical fullWidth>
            {grouped.map((group, i) => (
                <Stack key={i} space={1} vertical>
                    <Text variant="bold-h5">{group.title}</Text>
                    <Stack space={1} vertical>
                        {group.summaries.map((summary, j) => (
                            <Text variant="body-1" key={j}>
                                {summary}
                            </Text>
                        ))}
                    </Stack>
                </Stack>
            ))}
        </Stack>
    );
};

export default React.memo(ClinicalImpressions);
